import React from "react";
import { BaseQuestionType } from "../../../../../../../service/exercise";
import { indexToChar } from "../../../../../../../utils/common";
import { isTrue } from "../../../../../../../service/service";
import style from "../TopicPreview/index.module.scss";
import { QuestionItem } from "../TopicPreview";

interface TopicPreviewItemProps {
    data: QuestionItem;
}

export default function TopicPreviewItem({ data }: TopicPreviewItemProps) {
    function getRightOptions() {
        if (!data) return;
        if (
            ![
                BaseQuestionType.SingleChoice,
                BaseQuestionType.MultipleChoice,
                BaseQuestionType.Judge
            ].includes(data.queTypeId)
        )
            return;

        return (
            data?.optionModelList
                ?.map((item, index) => ({
                    ...item,
                    char:
                        data.queTypeId === BaseQuestionType.Judge
                            ? item.description
                            : indexToChar(index)
                }))
                .filter(item => isTrue(item.isRight))
                .map(item => item.char)
                .join("") || ""
        );
    }

    return (
        <div className={style.root}>
            <div className={style.info}>{data?.queTypeName}</div>

            <div className={style.trunk}>
                <div
                    className={style.title}
                    dangerouslySetInnerHTML={{
                        __html: data?.contentText || ""
                    }}
                />
            </div>

            {/* 多选，单选选项 */}
            <div className={style.options}>
                {[
                    BaseQuestionType.SingleChoice,
                    BaseQuestionType.MultipleChoice
                ].includes(data.queTypeId) &&
                    data.optionModelList.map((item, index) => {
                        return (
                            <div className={style.option} key={item.id}>
                                <span className={style.optionIndex}>
                                    {indexToChar(index)}.
                                </span>

                                <div
                                    className={style.optionText}
                                    dangerouslySetInnerHTML={{
                                        __html: item.description
                                    }}
                                />
                            </div>
                        );
                    })}
            </div>

            {/* 正确答案 */}
            {[
                BaseQuestionType.SingleChoice,
                BaseQuestionType.MultipleChoice,
                BaseQuestionType.Judge,
                BaseQuestionType.Fill
            ].includes(data.queTypeId) && (
                <div className={style.answer}>
                    <h1>【正确答案】{getRightOptions()} </h1>

                    {data.queTypeId === BaseQuestionType.Fill &&
                        data.optionModelList.map((item, index) => (
                            <p key={item.id}>
                                填空{index + 1}：{item.description}
                            </p>
                        ))}
                </div>
            )}

            {/* 主观题有参考答案 */}
            {data.queTypeId === BaseQuestionType.Subjective && (
                <div className={style.answerSuggested}>
                    <h1>
                        参考答案{" "}
                        <span className={style.answerTip}>
                            (活动结束后学生可见)
                        </span>
                    </h1>
                    <div
                        className={style.option}
                        dangerouslySetInnerHTML={{
                            __html: data.analysis ? data.analysis : "无"
                        }}
                    />
                </div>
            )}
        </div>
    );
}
